module.exports = __webpack_public_path__ + "assets/img/banner7.c42e3a43.png";